import { createFileRoute } from "@tanstack/react-router";
import { QrCodeIcon } from "lucide-react";
import { AttendanceGate } from "@/components/attendance/attendance-locked";
import { AttendanceView } from "@/components/attendance/attendance-view";
import { useLabels } from "@/hooks/use-labels";
import { attendanceSessionsQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/attendance/")({
  // A head start on the default view; the page renders its own skeleton.
  loader: ({ context }) => {
    warm(
      context.queryClient.ensureInfiniteQueryData(attendanceSessionsQuery({ scope: "upcoming" })),
    );
  },
  component: AttendancePage,
});

function AttendancePage() {
  const labels = useLabels();
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <QrCodeIcon className="size-3.5" />
            Attendance
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Attendance</h1>
          <p className="text-muted-foreground text-sm">
            Schedule {labels.session.lowerPlural} and record attendance with QR check-in.
          </p>
        </div>
        <AttendanceGate>
          <AttendanceView />
        </AttendanceGate>
      </div>
    </main>
  );
}
